<template>
  <a-modal
    title="选择字段"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    :width="800"
  >
    <div :style="{ borderBottom: '1px solid #E9E9E9' }">
      <a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange">
        全选
      </a-checkbox>
    </div>
    <br />
    <a-checkbox-group v-model="pickedData" @change="changeFiled">
      <a-row type="flex" class="checkbox-wrapper">
        <a-col v-for="(filed, idx) in allFields" :key="idx" :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-checkbox :value="filed.field">
            {{ filed.field_name }}
          </a-checkbox>
        </a-col>
      </a-row>
    </a-checkbox-group>
  </a-modal>
</template>
<script>
import { ref, reactive, toRefs, getCurrentInstance } from '@vue/composition-api'

export default {
  props: {
    allFields: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    // 获取当前实例
    const _this = getCurrentInstance()

    const state = reactive({
      visible: false,
      indeterminate: false,
      checkAll: false,
      pickedData: []
    })

    const methods = {
      showModal(value) {
        state.visible = true
        state.pickedData = value || []
        methods.changeFiled(state.pickedData)
      },
      changeFiled(checkedList) {
        state.indeterminate = checkedList.length > 0 && checkedList.length < props.allFields.length
        state.checkAll = checkedList.length === props.allFields.length
      },
      handleOk() {
        this.$emit('ok', state.pickedData)
        this.handleCancel()
      },
      handleCancel() {
        Object.assign(state, {
          visible: false,
          checkAll: false,
          indeterminate: false,
          pickedData: []
        })
      },
      onCheckAllChange(e) {
        Object.assign(state, {
          pickedData: e.target.checked ? props.allFields.map(item => item.field) : [],
          indeterminate: false,
          checkAll: e.target.checked,
        })
      },
    }

    return {
      ...toRefs(state),
      ...methods
    }
  }
}
</script>
<style lang='less' scoped>
/deep/.ant-checkbox-group{
  width: 100%;
  .ant-row-flex>div{
    margin-bottom: 15px;
  }
}

.checkbox-wrapper{
  max-height: 60vh;
  overflow-y: auto;
}
</style>
